var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2227 7.08333C8.01432 7.08333 6.01432 7.90833 4.47266 9.25L1.47266 6.25V13.75H8.97266L5.95599 10.7333C7.11432 9.76667 8.58932 9.16667 10.2227 9.16667C13.1727 9.16667 15.681 11.0917 16.556 13.75L18.531 13.1C17.3727 9.60833 14.0977 7.08333 10.2227 7.08333Z",
    fill: "#A3A9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.6a07fcea0160dc2e5973cc8a9e916afa.svg";
export { ForwardRef as ReactComponent };